export const logout = () => {
  return new Promise((resolve) => {
    localStorage.removeItem("user");
    resolve();
  });
}

export default () => {
  window.axios.interceptors.request.use(
    (config) => {
      let user = localStorage.getItem("user");
      if (user) {
        let token = JSON.parse(user).token;
        if (token) {
          config.headers["Authorization"] = `Bearer ${ token }`;
        }
      }
  
      return config;
    }, 
  
    (error) => {
      return Promise.reject(error);
    }
  );

  window.axios.interceptors.response.use(function (response) {
    return response;
  }, function (error) {
    let error_message = error.response.data.message;

    if (401 === error.response.status) {
      if (["Token expired",
        "Token invalid", 
        "Token blacklisted", 
        "Token not provided"].includes(error_message)) {
        localStorage.setItem("token_expired", true);
        logout()
          .then(() => {
            window.location.href = "/login";
          })
          .catch(() => {});

        return;
      } 
    } 
    return Promise.reject(error);
  });
}
